module.exports = __webpack_public_path__ + "img/content1.af702901.png";